import { CheckCircleOutline } from '@mui/icons-material';
import { Box, Divider, styled, Typography } from '@mui/material';
import { Column, Row } from 'components/Layout';
import PageContent from 'components/PageContent';
import Spacing from 'components/Spacing';

const Container = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
});

const SuccessIcon = styled(CheckCircleOutline)({
  opacity: 0.4,
  width: '140px',
  height: '140px',
});

const SuccessHeading = styled(Typography)(({ theme }) => ({
  fontSize: 26,
  color: theme.palette.text.rootColor,
}));

const ColumnContent = styled(Spacing)({
  maxWidth: '400px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  alignItems: 'center',
});

const ProcessCloseSuccess: React.FC = () => {
  return (
    <PageContent fullHeight>
      <Container>
        <Row fullWidth justify="center">
          <Column fullWidth centered>
            <ColumnContent size="sm">
              <SuccessIcon color="primary" />
              <SuccessHeading variant="h2">
                The vehicle's first close has been processed successfully.
              </SuccessHeading>
            </ColumnContent>
          </Column>
          <Divider orientation="vertical" flexItem />
        </Row>
      </Container>
    </PageContent>
  );
};

export default ProcessCloseSuccess;
